import { unref } from 'vue';
import type { PassengerDataValidation, PassengerKeys } from '../types';

export const getErrorMessage = (
  validation: PassengerDataValidation,
  property: PassengerKeys,
) => unref(validation[property]?.$errors[0]?.$message);
